import { useNavigate } from 'react-router-dom';

export default function withRouterNavigateHook(Component) {
    return function WrappedComponent(props) {
        const navigate = useNavigate();
        return <Component navigate={navigate} {...props} />;
    };
};